module.exports = __webpack_public_path__ + "img/thumbnail_HighlandCattle_f_melanistic.2c9f43d2.png";